import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default function () {
    const swiper = new Swiper('.js-services-slider', {
        slidesPerView: 1,
        spaceBetween: 12,
        loop: true,
        breakpoints: {
            640: {
                slidesPerView: 2,
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 16,
            },
        },
        modules: [Navigation],
        navigation: {
            nextEl: '.js-services-slider__next',
            prevEl: '.js-services-slider__prev',
        },
    });
}
